import { type ButtonHTMLAttributes, forwardRef } from "react";

import styles from "./Button.module.css";

type Variant = "primary" | "secondary" | "soft" | "ghost" | "success" | "outline";
type Size = "sm" | "md";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", size = "sm", className, ...props }, ref) => {
    const cls = [styles.btn, styles[variant], styles[size], className].filter(Boolean).join(" ");
    return <button ref={ref} className={cls} {...props} />;
  },
);

Button.displayName = "Button";
